// src/posthog.js
import posthog from 'posthog-js';
import { sanitizePostHogEvent } from './posthog-sanitization';

const isLocalOrDevelopment =
  process.env.NODE_ENV === 'development' ||
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname.includes('localhost');

if (!isLocalOrDevelopment && process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,

    // We handle routing manually
    capture_pageview: false,
    capture_pageleave: true,

    // Error tracking - capture unhandled errors and rejections (not console errors to avoid PHI leakage)
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },

    // Sanitize all events before sending - exclude PHI/PII
    before_send: (event) => sanitizePostHogEvent(event),

    // Privacy-first defaults
    autocapture: false,
    person_profiles: 'identified_only',

    session_recording: {
      maskAllInputs: true,
      blockClass: 'ph-no-capture',
    },
  });
}

export default posthog;
